/** Build tenant-scoped API URLs. Empty `apiBaseUrl` = same-origin (Vite dev proxy). */
export function resolveTenantApiUrl(
  apiBaseUrl: string,
  tenantCode: string,
  path: string,
  query?: Record<string, string | number | boolean | undefined>
): string {
  const trimmedBase = apiBaseUrl.replace(/\/+$/, '');
  const safeTenant = encodeURIComponent(tenantCode);
  const trimmedPath = path.startsWith('/') ? path : `/${path}`;
  const prefix = trimmedBase.length > 0 ? trimmedBase : '';
  let url = `${prefix}/api/${safeTenant}/v1${trimmedPath}`;

  if (query !== undefined) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    }
    const qs = params.toString();
    if (qs.length > 0) {
      url += `?${qs}`;
    }
  }

  return url;
}

/**
 * Legacy kiosk/payment routes: `/api/{tenant}/payments/...` rewrites to `/api/payments/...`
 * (no `/v1/` segment). Use for reconciliation manual-check and payment monitoring.
 */
export function resolveTenantLegacyApiUrl(
  apiBaseUrl: string,
  tenantCode: string,
  path: string
): string {
  const trimmedBase = apiBaseUrl.replace(/\/+$/, '');
  const safeTenant = encodeURIComponent(tenantCode);
  const trimmedPath = path.startsWith('/') ? path : `/${path}`;
  const prefix = trimmedBase.length > 0 ? trimmedBase : '';
  return `${prefix}/api/${safeTenant}${trimmedPath}`;
}
